import React, { useState } from 'react';
import { Button } from './Button';
import { Container } from './Container';
import heroImage from '../images/banner.png';
import heroPicture from '../images/hero-picture.jpg';

export default function Hero() {
  const [showVideo, setShowVideo] = useState(false);

  const handleWatchVideo = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  return (
    <Container className="pb-16 sm:pb-32 pt-8 text-center relative">
      <div className="mb-8 flex justify-center">
        <div className="relative rounded-full px-3 py-1 text-sm/6 text-blue-600 ring-1 ring-blue-900/10 hover:ring-blue-900/20">
          The 1<sup>st</sup> online platform to meet all your SEND needs from birth to 25!{' '}
        </div>
      </div>
      <h1 className="mx-auto max-w-4xl font-display text-5xl font-medium tracking-tight text-slate-900 sm:text-7xl">
        Welcome to a world of SEND where everything is possible
      </h1>
      <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-slate-700">
      enableSEND is the only digital platform catering to the special educational needs and
      disability (SEND) community. Covering a range of services and support from birth to 25.        <br />
      </p>
      <div className="mt-10 flex justify-center gap-x-6 relative z-30">
        <Button href="/signup" color="blue">Get Started</Button>
        <Button onClick={handleWatchVideo} variant="outline">
          <svg
            aria-hidden="true"
            className="h-3 w-3 flex-none fill-blue-600 group-active:fill-current"
          >
            <path d="m9.997 6.91-7.583 3.447A1 1 0 0 1 1 9.447V2.553a1 1 0 0 1 1.414-.91L9.997 5.09c.782.355.782 1.465 0 1.82Z" />
          </svg>
          <span className="ml-3">Watch video</span>
        </Button>
      </div>

      {/* Creative overlapping images layout */}
      <div className="hidden md:block absolute bottom-0 left-0 right-0 w-full h-64 z-10">
        {/* Left side image */}
        <img
          src={heroPicture}
          alt="SEND support illustration 1"
          className="absolute bottom-16 -left-32 w-80 h-56 object-cover rounded-lg shadow-lg"
        />
        
        {/* Right side image (existing) */}
        <img
          src={heroImage}
          alt="SEND support illustration 2"
          className="absolute bottom-16 -right-32 w-80 h-56 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Centered Video */}
      {showVideo && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={closeVideo}
        >
          <div
            className="relative bg-white rounded-lg shadow-lg"
            onClick={(e) => e.stopPropagation()} // Prevent click inside from closing
            style={{ width: '80%', maxWidth: '800px', aspectRatio: '16/9' }}
          >
            <iframe
              src="https://www.youtube.com/embed/NZwMWEflato?autoplay=1&mute=1"
              title="Video"
              className="w-full h-full rounded-lg"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </Container>
  );
}
